import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class TicketForwardUserMappingService {
  route = '/api/ticketforwardusermapping';

  constructor(private dataService: DataService) { }

  getAll(refresh: boolean) {
    return this.dataService.getData(this.route, refresh);
  }

  getByUser(userId: number, refresh: boolean) {
    return this.dataService.getData(`${this.route}/${userId}`, refresh);
  }

  save(data: any) {
    return this.dataService.post(this.route, data);
  }

  getUsers(refresh: boolean) {
    return this.dataService.getData('/api/lookup/user', refresh);
  }

  // Server-filtered by role - roleId 0 (or omitted) returns all enabled users.
  getUsersByRole(roleId: number, refresh: boolean) {
    return this.dataService.getData(`/api/lookup/usersbyrole/${roleId || 0}`, refresh);
  }

  getRoles(refresh: boolean) {
    return this.dataService.getData('/api/user/role', refresh);
  }
}
